import React, { useEffect, useState } from "react";
import NormalInput from "component/common/NormalInput";
import ErrorMessage from "component/common/ErrroMessage";
import { useForm } from "react-hook-form";
import SaveCancelBtn from "component/common/SaveCancelBtn";
import usePopup from "hooks/usePopUp";

import styles from "./styles.module.scss";
import { Toast } from "utils/toast";
import Popup from "component/common/Popup/Popup";
import { editSellerById, getSellerById } from "service/Payment";
import NormalOutlineButton from "component/common/NormalOutlineButton";

const AddAmount = ({
  getSellerListData,
  addupi,
  showModalData,
  editUpi,
  viewPage,
  id,
  setEditModal,
  sellerId_by_user,
  UPIcode,
  bankDetails,
}) => {
  const { successPopUp } = usePopup();

  const {
    register,
    formState: { errors },
    handleSubmit,
    setValue,
  } = useForm();

  const showModalUPI = () => {
    showModalData(true);
  };

  const handleCancel = () => {
    showModalData(false);
    setEditModal(false);
    resetFormDetails();
  };

  const [upiProduct, setUpiProduct] = useState({
    sellerProduct: "",
    UPICode: "",
  });

  const [upiProductList, setUpiProductList] = useState({
    sellerProductList: [],
    UPICodeList: [],
  });

  // get seller
  const getSellerDetails = async () => {
    if (id) {
      try {
        let response = await getSellerById(id);
        console.log(response, "response");
        if (response.status === 200) {
          const {
            UPICode,
            amount,
            emailId,
            mobileNo,
            sellerAddress,
            sellerName,
            sellerProduct,
          } = response.data.data;
          setValue("amount", amount);
          setValue("emailId", emailId);
          setValue("mobileNo", mobileNo);
          setValue("sellerAddress", sellerAddress);
          setValue("sellerName", sellerName);
          setUpiProductList({
            sellerProductList: sellerProduct,
            UPICodeList: UPICode,
          });
          setUpiProduct({
            sellerProduct: "",
            UPICode: "",
          });
        }
      } catch (error) {
        // Toast({ type: "error", message: error.data.message });
      }
    }
  };

  // isEdit
  const onSubmit = async (data) => {
    console.log(data, "data");
    if (UPIcode?.length > 0) {
      let body = {
        ...data,
        amount: data?.amount,
        sellerId_by_user: sellerId_by_user,
        UPICode: UPIcode,
        //  bankDetails:{
        //     accountHolderName: "",
        //     bankName: "",
        //     accountNumber: "",
        //     ifscCode: ""
        //  }
      };
      console.log(body, "boudasd");
      try {
        body.sellerId = id;
        let response = await editSellerById(body);
        if (response) {
            Toast({ type: "success", message: "Successfully updated" });
            handleCancel();
            getSellerListData();

        }
      } catch (error) {
        Toast({ type: "error", message: "Amount is not added" });
      }
    } else {
      let body = {
        ...data,
        amount: data?.amount,
        sellerId_by_user: sellerId_by_user,
        UPICode: [],
        bankDetails:{
            accountHolderName: bankDetails.accountHolderName,
            bankName:bankDetails.bankName ,
            accountNumber:bankDetails.accountNumber ,
            ifscCode:bankDetails.ifscCode 
        } 
      };
      console.log(body, "boudasd");
      try {
        body.sellerId = id;
        let response = await editSellerById(body);
        if (response) {
            Toast({ type: "success", message: "Successfully updated" });
            handleCancel();
            getSellerListData();

        }
      } catch (error) {
        Toast({ type: "error", message: "Amount is not added" });
      }
    }
  };

  const resetFormDetails = () => {
    setUpiProductList({
      sellerProductList: [],
      UPICodeList: [],
    });
    setUpiProduct({
      sellerProduct: "",
      UPICode: "",
    });
  };

  useEffect(() => {
    if (editUpi && addupi) {
      getSellerDetails();
    }
  }, [addupi]);

  useEffect(() => {
    resetFormDetails();
  }, []);

  // const { UPICodeList } = upiProductList;
  // const { UPICode } = upiProduct;

  return (
    <>
      {!viewPage && (
        <NormalOutlineButton label="Add Amount" onClick={showModalUPI} />
      )}

      <Popup isOpen={addupi} setPopup={() => handleCancel()}>
        <div className={styles.sell_product_form}>
          <div className={styles.sell_form_title}>
            <span>{`${editUpi ? "EDIT" : "ADD"} AMOUNT`}</span>
          </div>
          <div className="row">
            <div className="col-md-12 mt-4 mb-4 ">
              <NormalInput
                label="Total Amount"
                placeholder="Enter here"
                register={register("amount", {
                  required: true,
                  pattern: /^[1-9][0-9]*$/,
                })}
                error={errors.amount}
                type="number"
              />
              <ErrorMessage
                error={errors.amount}
                message={{
                  required: "Please enter total amount",
                  pattern: "Amount should greater than 0",
                }}
              />
            </div>
            <div className="col-md-6" />
          </div>
        </div>
        <SaveCancelBtn
          position="center"
          onCancel={() => handleCancel()}
          onSave={handleSubmit(onSubmit)}
        />
        {successPopUp()}
      </Popup>
    </>
  );
};

export default AddAmount;
